import React, { useState } from 'react'
import { Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import CustomInput from './CustomInput';
import { Eye, EyeOff } from 'assets';
import { FiArrowLeft } from 'react-icons/fi';
import CustomButton from 'components/CustomButton';
import { useNavigate } from 'react-router-dom';
import { API_POST_MAMBOO } from 'services';

const VerifikasiPassword = () => {
  const [isPasswordShow, setIsPasswordShow] = useState(false)
  const [password, setPassword] = useState('');
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const passwordIconAction = () => {
    setIsPasswordShow(!isPasswordShow)
  }

  const onChange = (e) => {
    const { name, value } = e.target
    setPassword(value)
    if (value === "a@a.a") setError('Email belum terdaftar, masukan email yang sudah terdaftar di Loka sebelumnya')
    else setError("")

  }

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true)

    // API_POST_MAMBOO.actions.forgotPassword({email}).then((resp) => {
    //   setIsLoading(false)
    // }).catch((err) => {
    //   console.log('err', err)
    // })
  }

  return (
    <Container>
      <div className="text-wrapper">
        <h3>Buat Password Baru</h3>
        <h6>Masukkan Password baru anda.
        </h6>
      </div>
      <Col>
        <Form className="auth-form" onSubmit={handleSubmit}>
          <FormGroup className="custom-form-group">
          <CustomInput
              label="Password"
              name="password"
              onChange={onChange}
              error={error}
              value={password}
              type={`${isPasswordShow ? "text" : "password"}`}
              secondLabelStyle={{ color: 'var(--brand)', cursor: "pointer" }}
              placeholder="Password"
              Icon={isPasswordShow ? Eye : EyeOff}
              iconAction={passwordIconAction}
              iconPosition="right"
            />
          </FormGroup>
          <FormGroup className="custom-form-group">
          <CustomInput
              label="Ulangi Password"
              name="ulangi_password"
              onChange={onChange}
              error={error}
              value={password}
              type={`${isPasswordShow ? "text" : "password"}`}
              secondLabelStyle={{ color: 'var(--brand)', cursor: "pointer" }}
              placeholder="Ulangi Password"
              Icon={isPasswordShow ? Eye : EyeOff}
              iconAction={passwordIconAction}
              iconPosition="right"
            />
          </FormGroup>
          <CustomButton
            label={
              isLoading ? (
                <>
                  <Spinner size="sm" color="light" />
                </>
              ) : (
                "Ubah Password"
              )
            }
            color="primary-btn"
            disabled={isLoading}
          />
        </Form>
      </Col>
    </Container>
  );
}

export default VerifikasiPassword;